import { render } from "./ErrorMessages.vue?vue&type=template&id=6e47b3ce&scoped=true"
import script from "./ErrorMessages.vue?vue&type=script&lang=js"
export * from "./ErrorMessages.vue?vue&type=script&lang=js"

import "./ErrorMessages.vue?vue&type=style&index=0&id=6e47b3ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e47b3ce"]])

export default __exports__